module.exports = {"baseDomain":"johku.com","bridgeUri":"https://app.johku.com/"}


//////////////////
// WEBPACK FOOTER
// ./config/local.json
// module id = mH2u
// module chunks = 1